import { useEffect } from "react";

import { useToastStore } from "../stores/toast-store.js";

const AUTO_DISMISS_MS = 4000;

const TONE_CLASS: Record<string, string> = {
  info: "bg-[var(--tg-secondary-bg)] text-[var(--tg-text)]",
  success: "bg-emerald-600 text-white",
  error: "bg-rose-600 text-white",
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      setTimeout(() => {
        dismiss(t.id);
      }, AUTO_DISMISS_MS),
    );
    return () => {
      for (const t of timers) clearTimeout(t);
    };
  }, [toasts, dismiss]);

  if (toasts.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-3"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto max-w-sm rounded-md px-3 py-2 text-sm shadow-lg ${TONE_CLASS[t.tone] ?? TONE_CLASS.info ?? ""}`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
